import { render, staticRenderFns } from "./Enforce2FaConfirmDialog.vue?vue&type=template&id=10a0e4ac&scoped=true"
import script from "./Enforce2FaConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Enforce2FaConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Enforce2FaConfirmDialog.vue?vue&type=style&index=0&id=10a0e4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a0e4ac",
  null
  
)

export default component.exports